export const ITEM_TYPES = ['Song', 'Prayer', 'Scripture', 'Offering', 'Announcement', 'Other'] as const;

export const MUSICAL_KEYS = [
  'C', 'C#', 'Db', 'D', 'D#', 'Eb', 'E', 'F', 'F#', 'Gb', 'G', 'G#', 'Ab', 'A', 'A#', 'Bb', 'B',
];

export const DEFAULT_SECTIONS = ['Call to Worship', 'Praise', 'Worship'];
